import { Typography } from "@atoms/typography";
import { FC } from "react";
import { useTranslation } from "next-i18next";
import styled from "styled-components";

export const BookingNoResults: FC = () => {
  const { t } = useTranslation("homes");
  return (
    <Container>
      <picture>
        <source srcSet="/images/sad-home.png" type="image/webp" />
        <img
          alt={t("sad-home")}
          srcSet="/images/sad-home.png"
          width="120"
          height="120"
        />
      </picture>
      <Typography variant="title2">{t("no-results-title")}</Typography>
      <Typography>{t("no-results-message")}</Typography>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 5em;
`;
